function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Modal from 'react-modal';
import { T, useTranslate } from 'shared/helper/translate';
import { getChinaLocalization } from 'shared/account/reducer';
import featureEnabled from 'shared/helper/feature';
import { getTrialFingerprintFlagged } from '../reducer';
import RubriqLoadingSpinner from '../components/RubriqLoadingSpinner';
import useNavigate from '../hooks/useNavigate';
export var CuriePreprintsModalActionButton = function CuriePreprintsModalActionButton(_ref) {
  var isLoading = _ref.isLoading,
    isChinaUser = _ref.isChinaUser,
    isChinaFreeTrialFeatureFlagEnabled = _ref.isChinaFreeTrialFeatureFlagEnabled,
    hasActivePlan = _ref.hasActivePlan,
    plan = _ref.plan,
    _ref$trialFingerprint = _ref.trialFingerprintFlagged,
    trialFingerprintFlagged = _ref$trialFingerprint === void 0 ? false : _ref$trialFingerprint,
    navigate = _ref.navigate,
    onHandleGroupBasedFreeTrialClick = _ref.onHandleGroupBasedFreeTrialClick;
  var paddleBillingForChina = featureEnabled('rubriq_china_also_uses_paddle');
  var useCartInsteadOfPaddle = isChinaUser && !paddleBillingForChina;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var shouldShowFreeTrial = function shouldShowFreeTrial() {
    if (hasActivePlan) return false;
    if (trialFingerprintFlagged) return false;
    if (useCartInsteadOfPaddle) {
      return !(plan !== null && plan !== void 0 && plan.freeTrialExpiration);
    }
    return true;
  };
  if (shouldShowFreeTrial()) {
    if (useCartInsteadOfPaddle && isChinaFreeTrialFeatureFlagEnabled) {
      return /*#__PURE__*/React.createElement("a", {
        href: "/c/CurieFreeTrialChina",
        className: "btn btn-primary btn-squared me-3 ".concat(isLoading ? 'disabled' : ''),
        onClick: onHandleGroupBasedFreeTrialClick
      }, isLoading ? /*#__PURE__*/React.createElement(RubriqLoadingSpinner, null) : /*#__PURE__*/React.createElement("span", {
        className: "text-span"
      }, /*#__PURE__*/React.createElement(T, {
        source: "curie.get-starter"
      })));
    }
    if (!useCartInsteadOfPaddle || !isChinaFreeTrialFeatureFlagEnabled) {
      return /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary btn-squared me-3",
        onClick: function onClick() {
          return navigate(useCartInsteadOfPaddle ? '/rubriq/subscribe' : '/rubriq/plan/subscribe/freetrial');
        },
        "aria-label": t('curie.get-starter')
      }, /*#__PURE__*/React.createElement(T, {
        source: "curie.get-starter"
      }));
    }
  }
  return /*#__PURE__*/React.createElement("button", {
    "aria-label": t('upgrade-now'),
    type: "button",
    className: "btn btn-primary btn-squared me-3",
    onClick: function onClick() {
      return navigate('/rubriq/subscribe');
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "upgrade-now"
  }));
};
var RubriqPreprintsModal = function RubriqPreprintsModal(_ref2) {
  var open = _ref2.open,
    onClose = _ref2.onClose;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    preferredGroup = _useSelector.user.preferredGroup,
    _useSelector$curie = _useSelector.curie,
    plans = _useSelector$curie.plans,
    plan = _useSelector$curie.plan;
  var isChinaUser = useSelector(getChinaLocalization);
  var trialFingerprintFlagged = useSelector(getTrialFingerprintFlagged);
  var _useTranslate2 = useTranslate(),
    t = _useTranslate2.t;
  var isInFreeTrial = (preferredGroup === null || preferredGroup === void 0 ? void 0 : preferredGroup.code) === 'CurieFreeTrialChina' || (preferredGroup === null || preferredGroup === void 0 ? void 0 : preferredGroup.code) === 'CurieFreeTrial';
  var hasActiveTrial = !!(plans !== null && plans !== void 0 && plans.free_trial) && plans.free_trial.status === 'active';
  var hasActivePremium = !!(plans !== null && plans !== void 0 && plans.premium) && plans.premium.status !== 'expired';
  var hasPreferredGroup = !!(plans !== null && plans !== void 0 && plans.preferredGroup);
  var hasActivePlan = hasActiveTrial || hasActivePremium || hasPreferredGroup || isInFreeTrial;
  var isChinaFreeTrialFeatureFlagEnabled = featureEnabled('curie_group_based_china_trials_enabled');
  var navigate = useNavigate();
  var handleGroupBasedFreeTrialClick = function handleGroupBasedFreeTrialClick(e) {
    e.preventDefault();
    if (isLoading) return;
    setIsLoading(true);
    var href = e.currentTarget.href;

    // Adding a 2-second delay to account for backend response time when joining the free-trial(China) group.
    fetch(href).then(function () {
      setTimeout(function () {
        navigate('/rubriq/editing?&origin=curie');
        onClose();
      }, 2000);
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, open && /*#__PURE__*/React.createElement(Modal, {
    appElement: window.document.querySelector('#researcher-app'),
    className: "react-modal",
    isOpen: true,
    overlayClassName: "react-modal-overlay"
  }, /*#__PURE__*/React.createElement("div", {
    className: "react-modal-header"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn-close",
    onClick: function onClick() {
      return onClose();
    },
    "aria-label": t('close')
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")), /*#__PURE__*/React.createElement("h1", {
    className: "react-modal-title"
  }, /*#__PURE__*/React.createElement(T, {
    source: "connection successful"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "react-modal-content"
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(T, {
    source: hasActivePlan ? 'curie.preprints-connection-success' : 'curie.preprints-connection-success-no-plan'
  }))), /*#__PURE__*/React.createElement("div", {
    className: "react-modal-footer"
  }, hasActivePlan ? /*#__PURE__*/React.createElement("a", {
    "aria-label": t('continue to research square'),
    className: "btn btn-primary btn-squared",
    href: "https://www.researchsquare.com/home"
  }, /*#__PURE__*/React.createElement(T, {
    source: "continue to research square"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CuriePreprintsModalActionButton, {
    isLoading: isLoading,
    isChinaUser: isChinaUser,
    isChinaFreeTrialFeatureFlagEnabled: isChinaFreeTrialFeatureFlagEnabled,
    hasActivePlan: hasActivePlan,
    plan: plan,
    trialFingerprintFlagged: trialFingerprintFlagged,
    navigate: navigate,
    onHandleGroupBasedFreeTrialClick: handleGroupBasedFreeTrialClick
  }), /*#__PURE__*/React.createElement("button", {
    "aria-label": t('no thanks'),
    type: "button",
    className: "btn btn-secondary btn-squared",
    onClick: function onClick() {
      return onClose();
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "no thanks"
  }))))));
};
export default RubriqPreprintsModal;